// No thousands separators: comma and dot are accepted only as decimal separators.
// Construct integer cents directly, avoiding floating-point multiplication.
export function euroToCents(value) {
  const match = String(value ?? '').trim().match(/^(\d+)(?:[,.](\d{1,2}))?$/)
  if (!match) return null
  const cents = Number(match[1]) * 100 + Number((match[2] || '').padEnd(2, '0'))
  return Number.isSafeInteger(cents) && cents <= 2147483647 ? cents : null
}

export function centsToEuroInput(cents) {
  if (cents == null || cents === '') return ''
  const value = Number(cents)
  if (!Number.isSafeInteger(value) || value < 0 || value > 2147483647) return ''
  return `${Math.floor(value / 100)},${String(value % 100).padStart(2, '0')}`
}
